// WHIT-524: the origin (https://<host>) of a page's canonical and hreflang
// addresses. It is the host of the page's own canonical address; a page that
// names none (the package hotel page, booking, enquiry) gets the site's host,
// rather than `https:///…`. Pure, so `node --test` can load it.

const PRODUCTION_HOST = 'tipptour.com';
const STAGING_HOST = 'showcase.allmyles.com';

// The host of an absolute address, or '' when there is none.
const hostOf = url =>
  String(url || '')
    .replace(/^https?:\/\//, '')
    .split('/')[0];

/**
 * @param {boolean} isProd
 * @param {string | undefined} canonicalProd
 * @param {string | undefined} canonicalStaging
 * @returns {string}
 */
const siteOrigin = (isProd, canonicalProd, canonicalStaging) => {
  const host = isProd
    ? hostOf(canonicalProd) || PRODUCTION_HOST
    : hostOf(canonicalStaging) || STAGING_HOST;
  return `https://${host}`;
};

module.exports = { siteOrigin };
